var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVectorGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 189,
    viewBox: "0 0 45 189",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.3333 6C44.3333 8.94552 41.9455 11.3333 39 11.3333C36.0545 11.3333 33.6667 8.94552 33.6667 6C33.6667 3.05448 36.0545 0.666667 39 0.666667C41.9455 0.666667 44.3333 3.05448 44.3333 6ZM39 7H35.5V5H39V7ZM28.5 7H25V5H28.5V7ZM25 7C23.981 7 22.9779 7.06621 21.9947 7.19445L21.736 5.21126C22.8047 5.07185 23.8942 5 25 5V7ZM16.1961 8.74486C14.3268 9.52003 12.5815 10.5349 10.9985 11.7513L9.77985 10.1655C11.4998 8.84376 13.3971 7.74045 15.43 6.89741L16.1961 8.74486ZM6.75133 15.9985C5.53487 17.5815 4.52002 19.3268 3.74486 21.1961L1.8974 20.43C2.74045 18.3971 3.84376 16.4998 5.16549 14.7799L6.75133 15.9985ZM2.19445 26.9947C2.06621 27.9779 2 28.981 2 30H0C0 28.8942 0.0718536 27.8047 0.211254 26.736L2.19445 26.9947ZM2 30V33.6136H0V30H2ZM2 40.8409V48.0682H0V40.8409H2ZM2 55.2955V62.5227H0V55.2955H2ZM2 69.75V76.9773H0V69.75H2ZM2 84.2045V91.4318H0V84.2045H2ZM2 98.6591V105.886H0V98.6591H2ZM2 113.114V120.341H0V113.114H2ZM2 127.568V134.795H0V127.568H2ZM2 142.023V149.25H0V142.023H2ZM2 156.477V163.705H0V156.477H2ZM2 170.932V178.159H0V170.932H2ZM2 185.386V189H0V185.386H2Z",
    fill: "#4AA0A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorGreen);
export default __webpack_public_path__ + "static/media/vectorGreen.64d16216b984ab836764ebc7740eb971.svg";
export { ForwardRef as ReactComponent };